import { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { featureRequestApi } from '../../api/endpoints';
import { getApiErrorMessage } from '../../api/client';
import { notify } from '../../components/Notifier';
import type { FeatureRequest } from '../../types';

interface RejectDialogProps {
  open: boolean;
  request: FeatureRequest;
  onClose: () => void;
  onRejected: (fr: FeatureRequest) => void;
}

/** Dialog từ chối một yêu cầu chức năng — lý do bắt buộc. */
export function RejectDialog({ open, request, onClose, onRejected }: RejectDialogProps): JSX.Element {
  const [reason, setReason] = useState('');
  const [rejecting, setRejecting] = useState(false);

  useEffect(() => {
    if (open) setReason('');
  }, [open]);

  const handleReject = async () => {
    if (reason.trim().length === 0) {
      notify('Vui lòng nhập lý do từ chối', 'warning');
      return;
    }
    setRejecting(true);
    try {
      const updated = await featureRequestApi.reject(request.id, reason.trim());
      notify('Đã từ chối yêu cầu', 'success');
      onRejected(updated);
    } catch (err) {
      notify(getApiErrorMessage(err, 'Không thể từ chối yêu cầu'), 'error');
    } finally {
      setRejecting(false);
    }
  };

  return (
    <Dialog open={open} onClose={rejecting ? undefined : onClose} fullWidth maxWidth="sm">
      <DialogTitle>Từ chối yêu cầu "{request.title}"</DialogTitle>
      <DialogContent>
        <TextField
          label="Lý do từ chối"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          fullWidth
          multiline
          minRows={3}
          size="small"
          required
          autoFocus
          sx={{ mt: 1 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={rejecting}>
          Huỷ
        </Button>
        <Button variant="contained" color="error" onClick={() => void handleReject()} disabled={rejecting}>
          {rejecting ? 'Đang từ chối…' : 'Từ chối'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
